import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Typography,
  Input,
  Modal,
  Button,
  Popover,
  Layout,
  Skeleton,
  Table,
  Select,
  Pagination,
  DatePicker,
  Card,
} from "antd";
import dayjs from "dayjs";
import { FaSearch, FaFilter, FaEye, FaArrowLeft } from "react-icons/fa";
import { Get } from "../../config/api/get";
import { COURSE, CATEGORIES } from "../../config/constants/api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../upcoming-lessons/upcoming-lessons.css";
import "./course-management.css";

const { Option } = Select;

function CourseManagement() {
  const token = useSelector((state) => state.user.userToken);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedUser] = useState(null);
  const [courses, setCourses] = useState([]);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    status: null,
    keyword: "",
    from: null,
    to: null,
  });

  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;

  useEffect(() => {
    getCourses();
    getCategories();
    // eslint-disable-next-line
  }, []);

  const getCategories = async () => {
    setLoading(true);
    const res = await Get(`${CATEGORIES.getAllcategories}`, token, {
      limit: "100",
    });


    setCategories(res.data.docs);
    setLoading(false);
  };

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });

    getCourses(pageNumber);
  };

  const handleSearch = (value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
  };

  const handleStatusChange = (value) => {
    setFilter({
      ...filter,
      category: value,
    });
  };

  const resetFilter = () => {
    setFilter({
      category: "",
      keyword: "",
      from: null,
      to: null,
    });
    getCourses(paginationConfig.pageNumber, paginationConfig.limit, "", true);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };

  const handleLimitChange = (pageSize) => {
    setPaginationConfig({
      ...paginationConfig,
      limit: pageSize,
      current: 1,
    });

    getCourses(1, pageSize);
  };

  const handleStatus = async () => {
    try {
      const index = courses.findIndex((user) => user._id === selectedUser._id);

      const response = await Get(
        COURSE.toggleStatus + "/" + selectedUser._id,
        token,
        {}
      );
      console.log(response);
      const newUsers = [...courses];

      newUsers[index].isActive = !selectedUser.isActive;
      setModalOpen(false);
      setCourses(newUsers);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getCourses = async (pageNumber, pageSize, search, reset = false) => {
    setLoading(true);
    try {
      const response = await Get(COURSE.getAllCourses, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig.limit.toString(),
        category: reset ? "" : filter.category || null,
        keyword: search ? search : null,
        from: reset ? "" : filter?.from ? filter?.from.toISOString() : "",
        to: reset ? "" : filter?.to ? filter?.to.toISOString() : "",
      });
      setLoading(false);
      if (response?.data?.docs) {
        setCourses(response?.data?.docs);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        message.error("Something went wrong!");
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };


  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="upcoming-lessons-pager-btn">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="upcoming-lessons-pager-btn">
          Next
        </button>
      );
    }
    return originalElement;
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "_id",
      key: "_id",
      render: (item) => (
        <button
          type="button"
          className="upcoming-lessons-view-btn"
          aria-label="View course"
          onClick={() => navigate("/course-details/" + item)}
        >
          <FaEye className="upcoming-lessons-view-icon" aria-hidden="true" />
        </button>
      ),
    },
    {
      title: "S. No.	",
      dataIndex: "key",
      key: "key",
      width: 100,
      render: (value, item, index) => (
        <span className="upcoming-lessons-index">
          {(index < 9 ? "0" : "") + (index + 1)}
        </span>
      ),
    },
    {
      title: "Course Code",
      dataIndex: "courseCode",
      key: "courseCode",
      render: (code) => (
        <span className="upcoming-lessons-cell-id">{code}</span>
      ),
    },
    {
      title: "Title	",
      dataIndex: "title",
      key: "title",
      render: (title) => (
        <span className="upcoming-lessons-cell-name" title={title}>
          {title}
        </span>
      ),
    },

    {
      title: "Category",
      dataIndex: "categories",
      key: "categories",
      render: (item) => (
        <span
          className="course-management-category-cell"
          title={item.map((c) => c.title).join(", ")}
        >
          {item.map((cat, index) => {
            return index !== item.length - 1 ? cat.title + ", " : cat.title;
          })}
        </span>
      ),
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      render: (val) => (
        <span className="upcoming-lessons-cell-date">{val}</span>
      ),
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (item) => (
        <span className="upcoming-lessons-cell-date">
          {dayjs(item).format("M/D/YYYY")}
        </span>
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (item) => (
        <span className="upcoming-lessons-cell-money">${item}</span>
      ),
    },
  ];

  const filterContent = (
    <div className="filterDropdown upcoming-lessons-filter-popover">
      <p className="upcoming-lessons-filter-head">Filter courses</p>
      <hr />

      <div className="filterDropdownBody">
        <p className="mainLabel">Start Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter.to}
          onChange={(e) => handleTo(e)}
        />

        <p className="mainLabel">Filter by Category:</p>

        {/* <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Status"
          value={filter.status}
          onChange={(e) => handleStatusChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "active", label: "Active" },
            { value: "inactive", label: "Inactive" },
          ]}
        /> */}

        <Select
          size={"large"}
          className="filterSelectBox upcoming-lessons-filter-select"
          placeholder="Select Category"
          value={filter.category}
          onChange={(e) => handleStatusChange(e)}
        >
          {categories.map((item) => (
            <Option key={item._id} value={item._id}>
              {item?.title}
            </Option>
          ))}
        </Select>

        <Button
          type="primary"
          shape="round"
          block
          size={"large"}
          className="mainButton primaryButton loginButton upcoming-lessons-filter-apply"
          onClick={() => getCourses()}
        >
          Apply
        </Button>
        <Button
          type="primary"
          shape="round"
          block
          size={"large"}
          className="mainButton primaryButton2 loginButton"
          onClick={() => resetFilter()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );
  console.log("courses", courses);
  return (
    <Layout
      className="configuration upcoming-lessons-page"
      style={{ minHeight: "100vh" }}
    >
      <Row className="blueBackground-old coursebnr course-management-hero">
        <Typography.Title
          level={1}
          className="fontFamily1 aboutbanner-content upcoming-lessons-hero-title"
        >
          Course Management
        </Typography.Title>
      </Row>

      <div className="boxDetails">
        <Row
          className="whiteBackground upcoming-lessons-section"
          style={{ justifyContent: "center" }}
        >
          <Col xs={24} lg={22} xl={21}>
            <div className="upcoming-lessons-inner">
              <Card className="infoBox upcoming-lessons-card" bordered={false}>
                <div className="upcoming-lessons-box">
                  <Row className="upcoming-lessons-toolbar" gutter={[16, 16]}>
                    <Col xs={24} md={14} lg={16}>
                      <div className="course-management-title-block">
                        <button
                          type="button"
                          className="course-management-inline-back"
                          aria-label="Go back"
                          onClick={() => navigate(-1)}
                        >
                          <FaArrowLeft aria-hidden="true" />
                        </button>
                        <Typography.Title
                          level={2}
                          className="fontFamily1 course-management-page-title"
                        >
                          Course Management
                        </Typography.Title>
                      </div>
                    </Col>
                    <Col
                      xs={24}
                      md={10}
                      lg={8}
                      className="course-management-actions-col"
                    >
                      <div className="course-management-primary-actions">
                        <Button
                          type="primary"
                          shape="round"
                          size={"large"}
                          className="loginButton"
                          onClick={() => navigate("/category")}
                        >
                          Add Category
                        </Button>
                        <Button
                          type="primary"
                          shape="round"
                          size={"large"}
                          className="loginButton"
                          onClick={() => navigate("/course-details/add")}
                        >
                          Add Course
                        </Button>
                      </div>
                    </Col>
                  </Row>

                  <Row className="course-management-sub-toolbar" gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <div className="course-management-page-size">
                        <span className="course-management-page-size-label">
                          Show
                        </span>
                        <Select
                          size={"large"}
                          className="chartSelectBox"
                          defaultValue={paginationConfig.limit}
                          onChange={(e) => handleLimitChange(e)}
                          style={{
                            width: 70,
                            textAlign: "left",
                          }}
                          options={[
                            { value: 10, label: "10" },
                            { value: 20, label: "20" },
                            { value: 30, label: "30" },
                            { value: 40, label: "40" },
                            { value: 50, label: "50" },
                          ]}
                        />
                        <span className="course-management-page-size-label">
                          entries
                        </span>
                      </div>
                    </Col>
                    <Col xs={24} md={12} className="upcoming-lessons-toolbar-actions">
                      <Popover
                        content={filterContent}
                        trigger="click"
                        open={open}
                        onOpenChange={handleOpenChange}
                        placement="bottomRight"
                        arrow={false}
                      >
                        <Button
                          type="primary"
                          shape="circle"
                          className="upcoming-lessons-filter-trigger"
                          aria-label="Open filters"
                        >
                          <FaFilter style={{ fontSize: 16, color: "white" }} />
                        </Button>
                      </Popover>
                      <Input
                        className="mainInput dashInput upcoming-lessons-search"
                        placeholder="Search courses…"
                        onChange={(e) => handleSearch(e.target.value)}
                        suffix={
                          <FaSearch
                            style={{
                              color: "#64748b",
                              fontSize: 16,
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              getCourses(
                                1,
                                paginationConfig.limit,
                                filter.keyword
                              )
                            }
                          />
                        }
                        onPressEnter={() =>
                          getCourses(1, paginationConfig.limit, filter.keyword)
                        }
                      />
                    </Col>
                  </Row>

                  <Row className="upcoming-lessons-table-shell">
                    {loading ? (
                      <div className="upcoming-lessons-skeleton-wrap">
                        <Skeleton active paragraph={{ rows: 6 }} />
                      </div>
                    ) : (
                      <div className="upcoming-lessons-table-wrap">
                        <Table
                          className="styledTable upcoming-lessons-table"
                          dataSource={courses}
                          columns={columns}
                          pagination={false}
                          rowKey={(record, index) =>
                            record._id ?? record.courseCode ?? `course-row-${index}`
                          }
                          scroll={{ x: "max-content" }}
                        />
                      </div>
                    )}
                  </Row>

                  <Row className="upcoming-lessons-pagination-row" gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <p className="fontFamily1 upcoming-lessons-pagination-meta">
                        {message}
                      </p>
                    </Col>
                    <Col xs={24} md={12}>
                      <div className="upcoming-lessons-pagination-controls">
                        <Pagination
                          className="styledPagination"
                          onChange={(e) => handlePageChange(e)}
                          current={parseInt(paginationConfig.pageNumber)}
                          pageSize={paginationConfig.limit}
                          total={paginationConfig.totalDocs}
                          itemRender={itemRender}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
      <Modal
        visible={modalOpen}
        onOk={() => handleStatus()}
        onCancel={() => setModalOpen(false)}
        okText="Yes"
        className="StyledModal"
        style={{
          left: 0,
          right: 0,
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
        }}
        cancelText="No"
        cancelButtonProps={{
          style: {
            border: "2px solid #2484c6",
            color: "#2484c6",
            height: "auto",
            padding: "6px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            marginTop: "15px",
          },
        }}
        okButtonProps={{
          style: {
            backgroundColor: "#2484c6",
            color: "white",
            marginTop: "15px",
            height: "auto",
            padding: "5px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            border: "2px solid #2484c6",
          },
        }}
      >
        <Typography.Title level={4} style={{ fontSize: "25px" }}>
          {selectedUser?.isActive ? "Deactivate" : "Activate"}
        </Typography.Title>
        <Typography.Text style={{ fontSize: 16 }}>
          Do You Want To {selectedUser?.isActive ? "Deactivate" : "Activate"}{" "}
          This Service Provider?
        </Typography.Text>
      </Modal>
    </Layout>
  );
}

export default CourseManagement;
